
export default function LegalValueStatement() {
  return (
    <section className="bg-[#1C1C1E] py-32">
      <div className="max-w-5xl mx-auto px-8 text-center">
        <h2 className="font-serif text-4xl md:text-6xl text-[#F7F5F2] leading-tight mb-12">
          We do not replace attorneys.
          <br />
          We strengthen the systems that support them.
        </h2>
        
        <div className="w-24 h-px bg-[#C8A14A] mx-auto my-12"></div>
        
        <p className="text-xl md:text-2xl text-[#8A8F98] leading-relaxed max-w-3xl mx-auto">
          carfuagency delivers operational intelligence designed to respect the standards, responsibilities, and discretion of the legal profession.
        </p>
      </div>
    </section>
  );
}
